import React from 'react';
import {
  LeftSide,
  CompanyInfo,
  Tabs,
  RightSide,
  Header,
  DateSelector,
  Logo,
  LineContent,
  ContainerLayout
} from './styles';
import RendimientoSkeleton from './RendimientoSkeleton';
import ReputationSkeleton from './ReputationSkeleton';
import ScoreSkeleton from './ScoreSkeleton';

const Skeleton = ({ device, portalWithTelBanner, inDesempeno, currentTab }) => {
  const isDesktop = device === 'desktop';

  const getCurrentTabSekeleton = () => {
    if (currentTab === 'reputation') return <ReputationSkeleton device={device} />;
    if (currentTab === 'score') return <ScoreSkeleton device={device} />;
    return <RendimientoSkeleton isDesktop={isDesktop} />;
  };

  return (
    <ContainerLayout isDesktop={isDesktop} inDesempeno={inDesempeno} portalWithTelBanner={portalWithTelBanner}>
      {!inDesempeno && (
        <LeftSide isDesktop={isDesktop}>
          {!isDesktop && <LineContent width='150px' marginBottom='16px' />}
          <CompanyInfo>
            <Logo />
            <section>
              <LineContent width='150px' marginBottom='14px' />
              <LineContent width='150px' />
            </section>
          </CompanyInfo>
          {isDesktop && <Tabs />}
        </LeftSide>
      )}
      <RightSide device={device} inDesempeno={inDesempeno}>
        {device === 'desktop' && (
          <Header isDesktop={isDesktop} inDesempeno={inDesempeno}>
            <section>
              <LineContent width={!isDesktop ? '150px' : '300px'} marginBottom='16px' />
              <LineContent width={!isDesktop ? '150px' : '450px'} />
            </section>
            {inDesempeno && <DateSelector isDesktop={isDesktop} />}
          </Header>
        )}
        {getCurrentTabSekeleton()}
      </RightSide>
    </ContainerLayout>
  );
};

export default Skeleton;
